import { getGetLabelListQueryKey, getLabelList } from '@modusign/openapi-client-category';
import { GetLabelListParams } from '@modusign/openapi-client-category/generated/model';
import { useQuery, UseQueryOptions } from 'react-query';
import { Awaited } from 'ts-essentials';

import { LabelFilters } from '@app/features/label/types';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import getAllList from '@app/libs/getAllList';

function useAllWorkspaceLabelList(
  filters: LabelFilters,
  options?: UseQueryOptions<
    Awaited<ReturnType<typeof getLabelList>>['labels'],
    Error,
    Awaited<ReturnType<typeof getLabelList>>['labels'],
    (string | GetLabelListParams)[]
  >
) {
  const workspaceId = useWorkspaceId();

  return useQuery(
    [...getGetLabelListQueryKey(workspaceId, filters), 'whole-list'],
    () =>
      getAllList({
        queryFn: (offset, limit) =>
          getLabelList(workspaceId, {
            offset,
            limit,
            ...filters,
          }).then((res) => ({ count: res.count, list: res.labels })),
        limit: 500,
      }),
    {
      staleTime: 5 * 1000,
      keepPreviousData: true,
      enabled: !!workspaceId,
      ...options,
    }
  );
}

export default useAllWorkspaceLabelList;
